import React from 'react';
import PropTypes from 'prop-types';
import { createStyles, withStyles } from '@material-ui/core';

import { Modal as ModalController, withModals } from 'ha/modules/ModalsLogic';
import Modal from 'ha/ui/next/Modal';

import SearchAlertMobile from './SearchAlertMobile';
import { MobileSearchAlertModalName } from '../../constants';

const styles = t =>
  createStyles({
    modal: {
      height: '100%',
      backgroundColor: t.palette.grey[50],
    },
  });

const MobileSearchAlertModal = ({ classes, handleClose }) => (
  <ModalController name={MobileSearchAlertModalName}>
    <Modal onClose={handleClose}>
      <div className={classes.modal}>
        <SearchAlertMobile handleClose={handleClose} />
      </div>
    </Modal>
  </ModalController>
);

MobileSearchAlertModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    modal: PropTypes.string.isRequired,
  }).isRequired,
};

export default withModals({ name: MobileSearchAlertModalName })(
  withStyles(styles)(MobileSearchAlertModal),
);
